import { Account } from '@accountHooks';

export function formatAccountLabel(account: Account): string {
  const namePart = account.nickname
    ? `${account.name} (${account.nickname})`
    : account.name;
  return `${namePart} \u2014 ${account.currency}`;
}
